module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_7_2.53029d23.jpeg";